<app>
  <div id="main-content">
    <div class="img-logo-top">
      <img src="" id="img-logo-top" alt="">
    </div>
    <div class="label-top">
      <label class="label-shop">{ state.name }</label><label class="label-page">ポイント確認ページ</label>
    </div>
    <div class="img-logo-bottom">
      <img src="" id="img-logo-bottom" alt="">
    </div>
    <main id="app-router">
      <router base="{ '#' }">
        <route path="{ props.shopId }">
          <login />
        </route>
        <route if="{ props.valid }" path="{ props.shopId }/password">
          <password />
        </route>
        <route if="{ props.valid }" path="user">
          <user />
        </route>
        <route if="{ props.valid }" path="result">
          <result />
        </route>
    </main>
    <hr if="{ state.urlShow || state.phoneShow || state.description || state.other}" class="border" />
    <div if="{ state.urlShow || state.phoneShow || state.description || state.other }" id="shop-detail">
      <div id="description"></div>
      <div id="other"></div>
      <div if="{ state.phoneShow }">
        TEL: { state.phone }
      </div>
      <div if="{ state.urlShow }">
        URL: <a href="{ state.url }">{ state.url }</a>
      </div>
    </div>
  </div>
  <kf-loader loader="{ props.loader }" />
  <kf-dialog dialog="{ props.dialog }" on-close="{ props.closeDialog }" />
  <script>
    import { Router, Route } from '@riotjs/route';
    import { KfLoader } from '@/common/components/kf-loader';
    import { KfDialog } from '@/common/components/kf-dialog';
    import Login from '@/point/login/login';
    import Password from '@/point/password/password';
    import User from '@/point/user/user';
    import Result from '@/point/result/result';
    import { formatPhone } from '@/common/utils/strings';
    import { convertSpwToState } from '@/point/convertSpwToState';
    export default {
      base: '#',
      components: {
        Login,
        Password,
        User,
        Result,
        Router,
        Route,
        KfLoader,
        KfDialog
      },

      state: {
        name: '',
        code: '',
        url: '',
        phone: '',
        urlShow: false,
        phoneShow: false,
        description: '',
        other: ''
      },

      onBeforeMount() {
        if (!this.props.valid) {
          return;
        }
        const style = document.createElement('style');
        document.head.appendChild(style);
        style.textContent = this.props.web.css;
      },

      onMounted() {
        if (!this.props.valid) {
          return;
        }
        const { name, code, url, phone, description, other } = convertSpwToState(this.props.web);
        this.state.name = name;
        this.state.url = url;
        this.state.phone = formatPhone(phone);
        this.state.urlShow = url !== '';
        this.state.phoneShow = formatPhone(phone) !== '';
        this.state.description = description;
        this.state.other = other;
        if (code.length > 0) {
          eval(code);
        }
        this.update();
        const descriptionDiv = document.getElementById('description');
        const otherDiv = document.getElementById('other');
        descriptionDiv.insertAdjacentHTML('afterbegin', description);
        otherDiv.insertAdjacentHTML('afterbegin', other);
      },

      blankPath() {
        location.replace('/point');
      }
    };
  </script>
  <style>
    #main-content {
      padding-top: 34px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      background-color: white;
      margin: 0 auto;
      margin-top: 40px;
      width: 550px;
      max-width: 100%;
    }

    #app-router {
      padding: 26px 32px 42px 32px;
    }

    #shop-detail {
      margin-top: 10px;
    }

    .label-top {
      display: flex;
      flex-wrap: nowrap;
      align-items: baseline;
      justify-content: center;
      min-width: 0;
      white-space: nowrap;
    }

    .label-top .label-shop {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .label-top .label-page {
      flex: 0 0 auto;
    }

    @media (max-width: 640px) {
      #main-content {
        width: 100%;
        max-width: 100%;
        padding-top: 0;
        margin-top: 0;
        overflow: hidden;
        border-radius: 8px;
      }

      #app-router {
        padding: 0 clamp(12px, 3vw, 16px);
      }

      #shop-detail {
        margin: 0;
        padding: 0 0 20px;
        color: #4d5664;
        font-size: 0.66rem;
        overflow-wrap: anywhere;
      }

      .border {
        border: 0;
        border-top: 1px solid #edf0f4;
        margin-top: 0;
        margin-right: clamp(18px, 6vw, 38px);
        margin-bottom: clamp(16px, 5vw, 26px);
        margin-left: clamp(18px, 6vw, 38px);
      }

      .label-top {
        flex-wrap: wrap;
        padding: 10px 0;
        font-size: clamp(15.6px, 6.0625vw, 26px);
        line-height: 1.35;
        white-space: normal;
      }

      .label-top .label-shop,
      .label-top .label-page {
        font-size: inherit;
        vertical-align: bottom;
      }

      .label-top .label-shop {
        overflow: visible;
        text-overflow: clip;
        white-space: normal;
        overflow-wrap: anywhere;
      }
      .label-top:before {
        width : 50%;
        height: 130%;
        border-width: 6px;
      }
    }
  </style>
</app>
